module.exports = __webpack_public_path__ + "static/media/Area_Train.3c57fcae.png";